module.exports = __webpack_public_path__ + "static/skill-banner-2eaacc742df1021bb230a61dba43cad5.jpg";